import { Flex } from "@chakra-ui/layout";
import { Spinner } from "@chakra-ui/spinner";
import { useChartData } from "../../hooks";
import InfoBanner from "../InfoBanner";
import Chart from "./Chart";
import Header from "./Header";

function WordCloud({ jsonObj, setJsonObj }) {
  const [result, isLoading] = useChartData("wordcloud", jsonObj, setJsonObj);

  if (isLoading) {
    return (
      <Flex justify="center" align="center" mt={{ base: "72", lg: "96" }} direction="column">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <>
      <Flex justify="center" align="center" mt={"32"} direction="column">
        <InfoBanner id="wordcloud" />
        <Header wordCloudData={result} />
        <Chart wordCloudData={result.data.slice(0, 150)} />
      </Flex>
    </>
  );
}

export default WordCloud;
